<div style="background-color: #dedede;line-height: 0px;">
    <ol class="breadcrumb breadcrumb_cstm" style="background: transparent;
              font-size: 12px;margin-bottom: 0 !important;">
        <li class="breadcrumb-item item" *ngFor="let item of breadcrumbsArray; let i = index">
            <a (click)="goToPageLink(item)">
                {{ item }}
            </a>
        </li>
    </ol>
</div>

<div class="card-container" *ngIf="emptyMsg">
    <div class="card-content">
        <img class="empty-msg-image" src="assets/images/assets.png"><br>
        <p class="msg-text text-center">No assets found, you need to add new assets from here.</p>
        <div class="re-btn-box">
            <button class="btn-custom" mat-raised-button (click)="addAssets()">Add Asset</button>
        </div>
    </div>
</div>

<div *ngIf="showList">
    <mat-toolbar class="top_headerbar">
        <h6 class="show-title">All Assets</h6>
       <div class="all_action_btns">
            <div class="input-group search_with_filter">
                <div class="input-group-btn search-panel">
                    <button mat-button [matMenuTriggerFor]="menu"><i class="material-icons">sort_by_alpha</i> Sort</button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item>Item 1</button>
                        <button mat-menu-item>Item 2</button>
                    </mat-menu>
                </div>

                <div class="input-group-btn search-panel">
                    <button mat-button [matMenuTriggerFor]="menu"><i class="material-icons">filter_list</i> Filter</button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item>Item 1</button>
                        <button mat-menu-item>Item 2</button>
                    </mat-menu>
                </div>
                <input type="hidden" name="search_param" value="all" id="search_param">
                <input type="text" class="form-control search_input" name="x" placeholder="Search term...">
            </div>
            <button class="more-btn-custom" mat-raised-button (click)="addAssets()">
                <i class="material-icons icon-layout-custom">add_circle</i><span class="m_l_5 mob_hide">Add New</span>
            </button>
       </div>
    </mat-toolbar>


    <div class="list-box-one" fxLayout fxLayout.xs="column" fxLayoutGap="10px" fxLayoutGap.xs="0"
        *ngFor="let clients of clientList;let idx = index;">
        <div class="box1" fxFlex="10%">
            <div class="select_icon">
                <i style="color: #21b51d;" class="material-icons" *ngIf="clients.checked">
                    check_circle_outline
                </i>
            </div>
            <div (click)="selectListItem(idx, clients.id)">
                <img class="list-image-custom" [src]="clients.image">
            </div>
        </div>
        <div class="box2" fxFlex="65%">
            <h4 class="header-layout">{{clients.assets_name}}</h4>
            <span class="subheader-layout">{{clients.mac_address}}</span>
        </div>
        <div class="box3" fxFlex="20%">
            <div class="align-txt-center" fxFlex="33%">
                <button mat-button (click)="viewAsset()"><i class="material-icons icon-orange-color">remove_red_eye</i></button>
            </div>

            <div class="align-txt-center" fxFlex="33%">
                <button mat-button (click)="editAssets()"><i class="material-icons icon-orange-color">edit</i></button>
            </div>
            <div class="align-txt-center" fxFlex="33%">
                <button mat-button><i class="material-icons icon-orange-color">delete</i></button>
            </div>
        </div>
    </div>
</div>